import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useClientIdSelector } from '../selectors/useClientIdSelector';
import { updateBoundaryStatsItems } from './stats.actionCreators';
import {
  boundaryStatsItemToBoundaryStatsRequestItem, isBoundaryStatItem,
  setStatsItemToLoading,
} from './stats.helpers';
import { calculateBoundaryStats } from './stats.repository';
import type { StatItem } from './stats.state';

export const useManageStats = () => {
  const dispatch = useDispatch();
  const clientId = useClientIdSelector();

  const calculateStats = useCallback(async (
    items: ReadonlyArray<StatItem>
  ) => {
    if (!clientId) {
      return;
    }

    const boundaryStatsItems = items.filter(isBoundaryStatItem);
    dispatch(updateBoundaryStatsItems(boundaryStatsItems.map(setStatsItemToLoading)));
    await calculateBoundaryStats(clientId, boundaryStatsItems.map(boundaryStatsItemToBoundaryStatsRequestItem));
  }, [clientId, dispatch]);

  return { calculateStats };
};
